// ---------------------------------------

// 公共
import { common } from './system/platform/common/zh'
// 核心
import { kernel } from './system/platform/kernel/zh'


// ---------------------------------------
// 模块

import { member } from './module/platform/member/zh'

import { advertising } from './module/platform/advertising/zh'

import { business } from './module/platform/business/zh'


export default {
  // 公共
  common: {
    ...common,
  },

  // 核心
  kernel: {
    ...kernel
  },


  // ------------------------------------

  // 广告
  advertising: {
    ...advertising,
  },

  // 会员
  member: {
    ...member,
  },

  // 业务
  business: {
    ...business
  }
}
